<template>
  <div class="item">
    <div class="hd flex">
      <span style="margin-right: 8px">{{ keys + 1 }}.</span>
      <span v-if="item.QuestionType == 3" class="mutil-tag">多选</span>
      <span v-html="item.Stem.replace(/\n/g, '<br/>')"></span>
      <span v-if="item.Required" class="required">*</span>
    </div>
    <div class="bd">
      {{ item.answer }}
      <!-- 判断题 单选题 -->
      <div v-if="item.QuestionType == 1 || item.QuestionType == 2">
        <!-- <div v-if="item.option && item.option.length > 4" class="zy-select">
          <select v-model="item.answer" class="select">
            <option value="">请选择</option>
            <option
              v-for="item2 in item.option"
              :key="item2.OptionId"
              :value="item2.OptionId"
            >
              {{ item2.Option }}
            </option>
          </select>
        </div> -->

        <!-- <van-radio-group v-model="item.answer">
          <div
            v-for="item2 in item.option"
            :key="item2.OptionId"
            :class="{ 'has-input': item2.Input }"
          >
            <van-radio
              checked-color="#333"
              :class="{ 'no-margin': item2.Input }"
              :name="item2.OptionId"
            >
              {{ item2.Option }}
            </van-radio>
            <div
              v-if="item2.Input && item.answer == item2.OptionId"
              class="own-div"
            >
              <van-field
                v-model="item2.InputValue"
                class="own-input"
                maxlength="1900"
                placeholder="请输入自定义内容"
              />
            </div>
          </div>
        </van-radio-group> -->
        <div v-for="(item2, i) in item.option" :key="i" class="list-item-p">
          <div
            class="list-item1 flex flex-align-center flex-wrap"
            :class="{ 'active-item1': item.answer == item2.OptionId }"
            @click="handlerItem1(item, item2)"
          >
            <span class="key-eng">
              {{ getKey(i + 1) }}
            </span>
            <span class="flex-1">{{ item2.Option }}</span>
            <van-icon
              v-if="item.answer == item2.OptionId"
              color="#D48806"
              name="success"
            />
          </div>
          <div class="p-custom-input">
            <div
              v-if="item2.Input && item.answer == item2.OptionId"
              class="zy-input custom-input"
            >
              <van-field
                v-model="item2.InputValue"
                placeholder="请输入自定义内容"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 多选题 -->
      <div v-if="item.QuestionType == 3">
        <div v-for="(item2, j) in item.option" :key="j" class="list-item-p">
          <div
            class="list-item1 flex"
            :class="{ 'active-item1': item.answer.includes(item2.OptionId) }"
            @click="handlerItem2(item, item2)"
          >
            <span class="key-eng">
              {{ getKey(j + 1) }}
            </span>
            <span class="flex-1">{{ item2.Option }}</span>
            <van-icon
              v-if="item.answer.includes(item2.OptionId)"
              color="#D48806"
              name="success"
            />
          </div>
          <div class="p-custom-input">
            <div
              v-if="item2.Input && item.answer.includes(item2.OptionId)"
              class="zy-input custom-input"
            >
              <van-field
                v-model="item2.InputValue"
                placeholder="请输入自定义内容"
              />
            </div>
          </div>
        </div>
        <!-- <van-checkbox-group v-model="item.answer">
          <div
            v-for="item2 in item.option"
            :key="item2.OptionId"
            :class="{ 'has-input': item2.Input }"
          >
            <van-checkbox
              checked-color="#333"
              :class="{ 'no-margin': item2.Input }"
              :name="item2.OptionId"
              shape="square"
            >
              {{ item2.Option }}
            </van-checkbox>
            <div
              v-if="item2.Input && item.answer.includes(item2.OptionId)"
              class="own-div"
            >
              <van-field
                v-model="item2.InputValue"
                class="own-input"
                placeholder="请输入自定义内容"
              />
            </div>
          </div>
        </van-checkbox-group> -->
      </div>
      <!-- 数值题 -->
      <div v-if="item.QuestionType == 4" class="flex flex-align-center">
        <div class="flex-1 zy-input">
          <van-field
            v-model="item.answer"
            class="text"
            maxlength="1900"
            :placeholder="item.Prompt || '请输入数值'"
            type="number"
            @blur="value = value.replace(/[^0-9.]/g)"
          >
            <template #button>
              <div v-if="item.Unit" class="ml10">
                {{ item.Unit }}
              </div>
            </template>
          </van-field>
        </div>
      </div>
      <!-- 填空题 -->
      <div v-if="item.QuestionType == 5">
        <div class="zy-input">
          <van-field
            v-model="item.answer"
            autosize
            border
            maxlength="1900"
            :placeholder="item.Prompt"
            rows="1"
            type="textarea"
          />
        </div>
        <!-- <input
            v-model="item.answer"
            class="text"
            :placeholder="item.Prompt"
            type="text"
          /> -->
      </div>
      <!-- 日期选择器 -->
      <div v-if="item.QuestionType == 6">
        <div class="zy-input">
          <van-cell is-link title="选择日期" @click="showCalendar = true">
            <template #value>
              {{ item.answer }}
            </template>
          </van-cell>
        </div>
        <van-action-sheet v-model:show="showCalendar">
          <van-datetime-picker
            v-model="date"
            :min-date="minDate"
            title="选择日期"
            type="date"
            @cancel="showCalendar = false"
            @confirm="onConfirm"
          />
        </van-action-sheet>
        <!-- 
        <van-calendar
          v-model:show="showCalendar"
          :min-date="minDate"
          safe-area-inset-bottom
          @confirm="onConfirm"
        /> -->
      </div>
      <!-- 时间选择器 -->
      <div v-if="item.QuestionType == 7">
        <div class="zy-input">
          <van-cell
            is-link
            title="选择时间"
            :value="item.answer"
            @click="showTime = true"
          />
        </div>
        <van-action-sheet v-model:show="showTime">
          <van-datetime-picker
            v-model="item.answer"
            title="选择时间"
            type="time"
            @cancel="showTime = false"
            @confirm="onConfirmTime"
          />
        </van-action-sheet>
      </div>
      <div v-if="item.QuestionType == 8">
        <zy-upload
          v-model:file="item.answer"
          :disabled="preview"
          :limit-size="500 * 1024"
          :max-count="9"
          :max-size="2 * 1024 * 1024"
        />
      </div>
      <div v-if="item.QuestionType == 10">
        <SelectArea v-model:data="item.answer" />
      </div>
    </div>
  </div>
</template>
<script>
  import ZyUpload from '@/components/ZyUploader/index.vue'
  import SelectArea from '@/components/SelectArea/SelectArea.vue'
  import { dateFormat } from '@/utils/filters.js'
  export default {
    name: 'QuestionItem',
    components: {
      ZyUpload,
      SelectArea,
    },
    props: {
      item: {
        type: Object,
        default: () => {
          return {}
        },
      },
      keys: {
        type: Number,
        default: 0,
      },
      preview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showTime: false,
        showCalendar: false,
        showPicker: false,
        fileList: [],
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(2100, 0, 31),
        date: new Date(),
        value: '',
      }
    },

    mounted() {
      // console.log('this.item', this.item)
    },
    methods: {
      handlerItem2(item, item2) {
        const id = item2.OptionId
        const result = item.answer.includes(id)
        if (result) {
          item.answer = item.answer.filter((box) => {
            return box != id
          })
        } else {
          item.answer.push(id)
        }
        // console.log('item', item.answer)
      },
      handlerItem1(item, item2) {
        item.answer = item2.OptionId
      },
      getKey(key) {
        return String.fromCharCode(64 + key)
      },
      blur(e) {
        console.log(e.value)
      },
      // formatDate(date) {
      //   return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      // },
      onConfirmTime(value) {
        this.showTime = false
        this.item.answer = value
      },
      onConfirm(value) {
        this.showCalendar = false
        this.item.answer = dateFormat(value, 'yyyy-MM-dd')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .item {
    .hd {
      font-size: 18px;
      margin: 0 0 10px;
      color: #333;
      font-weight: 500;
    }
    .list-item {
      line-height: 1.6;
    }
    .van-radio,
    .van-checkbox {
      padding: 13px 16px;
      margin-bottom: 10px;
      border: 1px solid #dde5ed;
      border-radius: 4px;
    }
  }
  .required {
    color: #f00;
    font-family: 'Courier New', Courier, monospace;
  }
  .has-input {
    margin-bottom: 10px;
  }
  .own-div {
    color: rgba(0, 0, 0, 0.3);
    font-size: 10px;
    margin-left: 26px;
  }

  .van-checkbox.no-margin {
    margin-bottom: 0;
  }
  .van-radio.no-margin {
    margin-bottom: 0;
  }
  .own-input {
    padding-top: 5px;
    padding-right: 0;
    padding-bottom: 0;
  }
  ::v-deep input.van-field__control {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 10px;
    border-radius: 4px;
  }
  .zy-input {
    border: none;
    background: #f7f8f9;
  }
  ::v-deep .zy-input .van-field__control {
    background: #f7f8f9;
  }
  ::v-deep .zy-input .van-cell {
    background: #f7f8f9;
  }
  .list-item1 {
    padding: 14px 16px;
    box-sizing: border-box;
    background: #f7f8f9;
    border-radius: 8px;
    &.active-item1 {
      color: #d48806;
      background: rgba(250, 173, 20, 0.14);
    }
  }
  .list-item-p + .list-item-p {
    margin-top: 16px;
  }
  // .list-item2{

  // }
  .key-eng {
    margin-right: 10px;
  }
  .p-custom-input {
    padding-left: 32px;
    box-sizing: border-box;
    margin-top: 16px;
  }
  .custom-input {
    border-radius: 8px;
  }
  .mutil-tag {
    display: inline-block;
    min-width: 40px;
    width: 40px;
    height: 22px;
    color: #d48806;
    background: #fff7f0;
    border-radius: 4px;
    font-size: 12px;
    line-height: 22px;
    text-align: center;
    margin-right: 8px;
    position: relative;
    bottom: 0px;
    border: 1px solid #ffc8a3;
  }
  .hd {
    font-size: 16px !important;
    color: #000 !important;
  }
</style>
